module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "supervisor-feedback"
  }, [(!_vm.selectedSubmission) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (_vm.terms) ? _c('div', {
    staticClass: "panel-body feedback"
  }, [_c('div', {
    staticClass: "selects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Terms")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.term),
      expression: "selected.term"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected.term = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getInstructorCourses]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select Term")]), _vm._v(" "), _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                                    " + _vm._s(term.name) + "\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.courses) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Courses")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.instance),
      expression: "selected.instance"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected.instance = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCourse]
    }
  }, [_c('option', {
    attrs: {
      "default": "",
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Course")]), _vm._v(" "), _vm._l((_vm.courses), function(course) {
    return (_vm.isInPathAndFocus(course)) ? _c('option', {
      domProps: {
        "value": course.id
      }
    }, [_vm._v("\n                                    " + _vm._s(course.associated.name) + "            \n\n                                ")]) : _vm._e()
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.assignments) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Assignments")]), _vm._v(" "), (_vm.assignments.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.assignment),
      expression: "selected.assignment"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected.assignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getSubmissions]
    }
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('option', {
      domProps: {
        "value": assignment.id
      }
    }, [_vm._v("\n                                    Week " + _vm._s(assignment.week) + ": " + _vm._s(assignment.name) + " \n                                ")])
  })) : _c('div', {
    staticClass: "no-assignments"
  }, [_c('p', [_vm._v("No assignments found for this course.")])])]) : _vm._e()])])]), _vm._v(" "), (_vm.students) ? _c('div', {
    staticClass: "assignments"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Submissions\n                    "), _c('button', {
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.uploadAllFeedback()
      }
    }
  }, [_vm._v("Upload all feedback")]), _vm._v(" "), (_vm.downloadingAll) ? _c('div', {
    staticClass: "download-progress-wrapper"
  }, [_c('span', {
    staticClass: "download-stage"
  }, [_vm._v(_vm._s(_vm.downloadStage))]), _vm._v(" "), _c('div', {
    staticClass: "download-progress"
  }, [_c('div', {
    staticClass: "download-progress-bar",
    style: ({
      width: _vm.downloadProgress + '%'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "download-progress-text"
  }, [_vm._v(_vm._s(_vm.downloadProgress) + "%")])])]) : _c('span', {
    staticClass: "download-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadAllSubmissions(false)
      }
    }
  }, [_vm._v("Download all")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadAllSubmissions(true)
      }
    }
  }, [_vm._v("Download latest")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "students"
  }, _vm._l((_vm.students), function(student) {
    return _c('li', {
      staticClass: "student"
    }, [_c('div', {
      staticClass: "student-header"
    }, [_c('h4', [(student.submissions && student.submissions.length) ? _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'student',
          params: {
            studentId: student.studentId
          },
          query: {
            userId: student.submissions[0].student.id,
            term: _vm.selected.term
          }
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(student.firstName) + " " + _vm._s(student.lastName) + "\n                                ")]) : _c('span', [_vm._v(_vm._s(student.firstName) + " " + _vm._s(student.lastName))])], 1)]), _vm._v(" "), _c('ul', {
      staticClass: "submissions"
    }, _vm._l((student.submissions), function(submission) {
      return _c('li', [_c('div', {
        staticClass: "student-submission"
      }, [_c('div', {
        staticClass: "submission"
      }, [_c('span', [_vm._v("Submitted " + _vm._s(_vm._f("longDate")(submission.createdAt)) + " "), (submission.grade || submission.grade === 0) ? _c('i', [_vm._v(" - Grade: " + _vm._s(submission.grade) + "%")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "video-buttons"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.toggleComments(submission.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-comments",
        class: {
          'open': _vm.displayedComments.includes(submission.id)
        },
        attrs: {
          "title": "View comments"
        }
      })]), _vm._v(" "), _c('a', {
        attrs: {
          "title": "Record feedback",
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.selectSubmission(submission)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-video-camera",
        attrs: {
          "title": "Record feedback"
        }
      })]), _vm._v(" "), _c('label', {
        staticClass: "file-upload",
        attrs: {
          "title": "Upload video"
        }
      }, [_c('i', {
        staticClass: "fa fa-upload"
      }), _vm._v(" "), _c('input', {
        staticClass: "hidden",
        attrs: {
          "type": "file",
          "accept": "video/mp4,video/webm"
        },
        on: {
          "change": function($event) {
            _vm.uploadExternalVideo($event, submission)
          }
        }
      })]), _vm._v(" "), (!submission.newFeedback && _vm.termIsOngoing && (_vm.isOverdue(submission) || submission.feedbacks && submission.feedbacks.length)) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.gradeOnlyFeedback.submission = submission
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit",
        attrs: {
          "title": "Grade submission without feedback"
        }
      })]) : _vm._e()])]), _vm._v(" "), (submission.downloading) ? _c('span', {
        staticClass: "download-progress-wrapper submission-download"
      }, [_c('span', {
        staticClass: "download-stage"
      }, [_vm._v(_vm._s(submission.downloadStage))]), _vm._v(" "), _c('div', {
        staticClass: "download-progress"
      }, [_c('div', {
        staticClass: "download-progress-bar",
        style: ({
          width: submission.downloadProgress + '%'
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "download-progress-text"
      }, [_vm._v(_vm._s(submission.downloadProgress) + "%")])])]) : _vm._e(), _vm._v(" "), (!submission.downloading && submission.url && submission.url.length) ? _c('span', {
        staticClass: "urls"
      }, [_c('a', {
        staticClass: "btn btn-success control-btn",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadSubmissionFiles(submission)
          }
        }
      }, [_vm._v("\n                                                Download all "), _c('i', {
        staticClass: "fa fa-download"
      })]), _vm._v(" "), _vm._l((submission.url), function(url, $index) {
        return _c('a', {
          attrs: {
            "href": _vm.isImageUrl(url) ? '#' : url,
            "target": _vm.isImageUrl(url) ? null : '_blank'
          },
          on: {
            "click": function($event) {
              _vm.isImageUrl(url) ? _vm.downloadFile(url, $event) : null
            }
          }
        }, [_vm._v("\n                                                Download " + _vm._s($index + 1) + "\n                                                "), _c('i', {
          staticClass: "fa fa-download"
        })])
      })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "feedback-buttons"
      }, [(submission.feedbacks && submission.feedbacks.length) ? _c('span', _vm._l((submission.feedbacks), function(feedback) {
        return _c('a', {
          attrs: {
            "title": "Watch feedback",
            "href": feedback.body,
            "target": "_blank"
          }
        }, [_vm._v("\n                                                Feedback  (" + _vm._s(_vm._f("monthAndDay")(feedback.createdAt)) + ")\n                                                "), _c('i', {
          staticClass: "fa fa-share",
          attrs: {
            "aria-hidden": "true"
          }
        })])
      })) : _vm._e()])]), _vm._v(" "), (_vm.displayedComments.includes(submission.id)) ? _c('div', [(submission.comments) ? _c('div', {
        staticClass: "comments-box"
      }, [_vm._v(_vm._s(submission.comments.trim()))]) : _vm._e(), _vm._v(" "), (submission.supervisorComments && submission.supervisorComments.length) ? _c('div', {
        staticClass: "supervisor-comments"
      }, _vm._l((submission.supervisorComments), function(comment) {
        return _c('div', {
          staticClass: "comments-box",
          domProps: {
            "innerHTML": _vm._s(comment)
          }
        })
      })) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "supervisor-comment"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (submission.supervisorComment),
          expression: "submission.supervisorComment"
        }],
        staticClass: "form-control",
        attrs: {
          "placeholder": "Enter any comments here"
        },
        domProps: {
          "value": (submission.supervisorComment)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            submission.supervisorComment = $event.target.value
          }
        }
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-success control-btn",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.saveSupervisorComment(submission)
          }
        }
      }, [_vm._v("Save Comment")])])]) : _vm._e(), _vm._v(" "), (submission.newFeedback) ? _c('div', {
        staticClass: "new-feedback-wrapper"
      }, [_c('video', {
        staticClass: "new-feedback",
        attrs: {
          "src": submission.newFeedback.body,
          "controls": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (submission.newFeedback.grade),
          expression: "submission.newFeedback.grade"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": "Enter Grade (%)",
          "min": "0",
          "max": "100",
          "readonly": _vm.uploading
        },
        domProps: {
          "value": (submission.newFeedback.grade)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            submission.newFeedback.grade = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('label', {
        staticClass: "checkbox-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (submission.applyToAll),
          expression: "submission.applyToAll"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(submission.applyToAll) ? _vm._i(submission.applyToAll, null) > -1 : (submission.applyToAll)
        },
        on: {
          "__c": function($event) {
            var $$a = submission.applyToAll,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (submission.applyToAll = $$a.concat([$$v]))
              } else {
                $$i > -1 && (submission.applyToAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              submission.applyToAll = $$c
            }
          }
        }
      }), _vm._v("\n                                        Apply to all submissions for this student in all courses this week?\n                                    ")]), _vm._v(" "), _c('div', {
        staticClass: "buttons"
      }, [_c('button', {
        staticClass: "btn btn-success",
        attrs: {
          "disabled": _vm.uploading
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.uploadSingleFeedback(submission)
          }
        }
      }, [_vm._v("Upload "), _c('i', {
        staticClass: "fa fa-upload"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-error",
        attrs: {
          "disabled": _vm.uploading
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.discardRecording(student.studentId, submission.id)
          }
        }
      }, [_vm._v("Discard "), _c('i', {
        staticClass: "fa fa-trash"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-primary",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadRecording(submission)
          }
        }
      }, [_vm._v("Download "), _c('i', {
        staticClass: "fa fa-download"
      })])])]) : _vm._e(), _vm._v(" "), (_vm.gradeOnlyFeedback.submission && _vm.gradeOnlyFeedback.submission.id === submission.id) ? _c('div', {
        staticClass: "grade-only-feedback"
      }, [_c('div', {
        staticClass: "form-group radio-inputs"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.gradeOnlyFeedback.videoType),
          expression: "gradeOnlyFeedback.videoType"
        }],
        attrs: {
          "type": "radio",
          "value": "placeholderVideo"
        },
        domProps: {
          "checked": _vm._q(_vm.gradeOnlyFeedback.videoType, "placeholderVideo")
        },
        on: {
          "__c": function($event) {
            _vm.gradeOnlyFeedback.videoType = "placeholderVideo"
          }
        }
      }), _vm._v("\n                                            Use placeholder video\n                                        ")]), _vm._v(" "), (submission.feedbacks && submission.feedbacks.length) ? _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.gradeOnlyFeedback.videoType),
          expression: "gradeOnlyFeedback.videoType"
        }],
        attrs: {
          "type": "radio",
          "value": "previousVideo"
        },
        domProps: {
          "checked": _vm._q(_vm.gradeOnlyFeedback.videoType, "previousVideo")
        },
        on: {
          "__c": function($event) {
            _vm.gradeOnlyFeedback.videoType = "previousVideo"
          }
        }
      }), _vm._v("\n                                            Use previous feedback video\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.gradeOnlyFeedback.grade),
          expression: "gradeOnlyFeedback.grade"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": "Enter Grade (%)",
          "min": "0",
          "max": "100",
          "readonly": _vm.uploading
        },
        domProps: {
          "value": (_vm.gradeOnlyFeedback.grade)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.gradeOnlyFeedback.grade = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group buttons"
      }, [_c('button', {
        staticClass: "btn btn-success",
        attrs: {
          "disabled": _vm.uploading || _vm.gradeOnlyFeedback.grade === null
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.submitGradeOnlyFeedback(submission)
          }
        }
      }, [_vm._v("Submit Grade "), _c('i', {
        staticClass: "fa fa-upload"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-error",
        attrs: {
          "disabled": _vm.uploading
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.gradeOnlyFeedback.submission = null;
            _vm.gradeOnlyFeedback.grade = null;
            _vm.gradeOnlyFeedback.videoType = 'placeholderVideo'
          }
        }
      }, [_vm._v("Cancel "), _c('i', {
        staticClass: "fa fa-times"
      })])])]) : _vm._e()])
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "upload-all-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.uploadAllFeedback()
      }
    }
  }, [_vm._v("Upload all feedback")])])]) : _c('div', {
    staticClass: "assignments no-students"
  }, [_vm._m(1), _vm._v(" "), _c('h4', [_vm._v("Please select a term, course, and assignment to view submissions")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubmission),
      expression: "selectedSubmission"
    }],
    staticClass: "recorder"
  }, [(_vm.showAudioSourceModal) ? _c('div', {
    staticClass: "overlay audio-source",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAudioSourceModal = false
      }
    }
  }, [_c('div', {
    staticClass: "audio-source-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h5', {}, [_vm._v("Select audio source")]), _vm._v(" "), _c('div', {
    staticClass: "audio-sources flex-col"
  }, _vm._l((_vm.mediaDevices.availableAudioSources), function(source) {
    return _c('div', {
      key: source.deviceId,
      staticClass: "audio-source-item",
      class: {
        'selected': _vm.mediaDevices.selectedAudioSource.deviceId === source.deviceId
      },
      on: {
        "click": function($event) {
          _vm.selectAudioSource(source)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-microphone"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(source.label || 'Microphone'))]), _vm._v(" "), (_vm.mediaDevices.selectedAudioSource.deviceId === source.deviceId) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "buttons flex"
  }, [_c('button', {
    staticClass: "btn btn-error",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAudioSourceModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.applyAudioSource()
      }
    }
  }, [_vm._v("Apply")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controls flex align-center justify-between"
  }, [_c('div', {
    staticClass: "left flex align-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitRecorder($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("Back")]), _vm._v(" "), (!_vm.isRecording && !_vm.isPaused) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.startPreview(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _vm._v("Select video source")]) : _vm._e(), _vm._v(" "), (!_vm.isRecording && !_vm.isPaused) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openAudioSourceSelector()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-volume-up"
  }), _vm._v("Select audio source")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(_vm.isRecording || _vm.isPaused) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isPaused ? _vm.resumeRecording() : _vm.pauseRecording()
      }
    }
  }, [(!_vm.isPaused) ? _c('span', [_c('i', {
    staticClass: "ri-pause-circle-line"
  }), _vm._v("Pause")]) : _c('span', [_c('i', {
    staticClass: "ri-play-circle-line"
  }), _vm._v("Resume")])]) : _vm._e(), _vm._v(" "), (!_vm.isPaused) ? _c('button', {
    staticClass: "btn btn-sm btn-success recording-button",
    class: {
      'record': _vm.isRecording
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isRecording ? _vm.stopRecording() : _vm.startRecording()
      }
    }
  }, [(_vm.isRecording) ? _c('span', {
    staticClass: "recording-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.isRecording) ? _c('span', [_vm._v(_vm._s(_vm._f("secondsToMs")(_vm.recordingTime)))]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.isRecording ? 'Stop' : 'Start Recording') + " \n\n                    "), _c('i', {
    class: _vm.isRecording ? 'ri-stop-circle-line' : 'ri-record-circle-line'
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "recording",
    class: {
      'recording-frame': !_vm.previewing, 'is-recording': _vm.isRecording, 'paused': _vm.isPaused
    }
  }, [_c('video', {
    ref: "screenPreview",
    attrs: {
      "autoplay": "",
      "muted": ""
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Assignment Feedback "), _c('a', {
    staticClass: "instructions",
    attrs: {
      "title": "View instructions",
      "href": "https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/POR-Portal+Feedback+Instructions-240226-182629.pdf",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Submissions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e4f4a2f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 2027
// module chunks = 2